import React, { useEffect, useContext } from 'react';
import './ibBachelor.scss';

import ReactMarkdown from 'react-markdown';
import { baseURL } from '../../../../../api';

import Dropdown from '../../../../Globals/Dropdown';
import { Image } from 'react-bootstrap';

// CONTEXT
import CurriculumContext from '../../../../../contexts/pages/curriculum/curriculumContext';

const IbBachelor = () => {

    const curriculumContext = useContext(CurriculumContext);
    const { ibBachelor, getCurriculum } = curriculumContext;

    useEffect(() => {
        getCurriculum();
        // eslint-disable-next-line
    }, []);

    return (
        <div className="subpage ib-bachelor">
            <div className="ib-bachelor-inner">

                {/* Introducción de Programas Internacionales (Oculta a solicitud) */}
                {/*
                <div className="international-programs-introduction">
                    <div className="ib-bachelor-title">
                        Bachillerato Internacional
                    </div>

                    <div className="ib-bachelor-text">
                        <p>
                            El Bachillerato Internacional (IB) es un sistema educativo global
                            fundado en Suiza en 1968 que ofrece cuatro programas dirigidos a
                            estudiantes de 3 a 19 años. Su enfoque promueve el pensamiento
                            crítico, la investigación y una mentalidad internacional.
                        </p>

                        <div>
                            <ul style={{
                                color: "#0a415d",
                                fontWeight: "300",
                                fontSize: "1rem",
                                textAlign: "justify",
                                whiteSpace: "pre-line"
                            }}>
                                <li>
                                    <strong>Metodología activa: </strong>
                                    <span>
                                        Prioriza la investigación, el análisis y la reflexión
                                        frente a la simple memorización.
                                    </span>
                                </li>

                                <li>
                                    <strong>Reconocimiento mundial: </strong>
                                    <span>
                                        Sus programas cuentan con reconocimiento internacional
                                        y preparan a los estudiantes para continuar sus estudios
                                        universitarios en diferentes países.
                                    </span>
                                </li>

                                <li>
                                    <strong>Colegios autorizados: </strong>
                                    <span>
                                        Solo las instituciones autorizadas como IB World Schools
                                        pueden impartir oficialmente los programas del
                                        Bachillerato Internacional.
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                */}

                {/* =========================================
                    TABS / CARDS DE PROGRAMA (OCULTAS TEMPORALMENTE SEGÚN AJUSTES)
                ========================================= */}
                {/*
                <div className="program-tabs">
                    <div className="program-mini-cards">
                        <button
                            type="button"
                            className={`program-mini-card ${activeTab === "ib" ? "active" : ""}`}
                            onClick={() => handleTabClick("ib")}
                        >
                            <div className="program-mini-card-content">
                                <span className="program-mini-card-label">PROGRAMA IB</span>
                                <h3>Programa PD</h3>
                                <p>Programa del Diploma</p>
                            </div>
                        </button>
                        <button
                            type="button"
                            className={`program-mini-card ${activeTab === "pai" ? "active" : ""}`}
                            onClick={() => handleTabClick("pai")}
                        >
                            <div className="program-mini-card-content">
                                <span className="program-mini-card-label">PROGRAMA IB</span>
                                <h3>Programa PAI</h3>
                                <p>Programa de Años Intermedios</p>
                            </div>
                        </button>
                    </div>
                </div>
                */}

                {/* =========================================
                    DEFINICIÓN Y CONTENIDO DEL PROGRAMA DEL DIPLOMA (PD) DIRECTO
                ========================================= */}
                <div className="program-tabs-content">
                    {/* PROGRAMA PD SIEMPRE VISIBLE DIRECTAMENTE DEBAJO DEL TEXTO PRINCIPAL */}
                    <div className="program-tab-panel">

                            <div className="ib-bachelor-title">
                                Programa del Diploma del Bachillerato Internacional (IB)
                            </div>

                            <div className="ib-bachelor-text">
                                <ReactMarkdown>
                                    {ibBachelor ? ibBachelor.contenido : ""}
                                </ReactMarkdown>
                            </div>

                            {ibBachelor ? (
                                <div className="content-ib">
                                    {/* LOGO IB */}
                                    {ibBachelor.grafico_ib && ibBachelor.grafico_ib.url && (
                                        <div className="logo-ib">
                                            <Image
                                                src={`${baseURL}${ibBachelor.grafico_ib.url}`}
                                                alt="image-logo-ib"
                                            />
                                        </div>
                                    )}

                                    {/* DESCRIPCIÓN */}
                                    <div className="ib-bachelor-text">
                                        <p>
                                            A continuación, se presenta una síntesis
                                            de los diversos grupos de materias, con
                                            información extraída del sitio web del BI
                                            (www.ibo.org) y un breve detalle de las
                                            asignaturas que forman parte del Programa
                                            del Diploma en nuestro Colegio.
                                        </p>
                                    </div>

                                    {/* GRUPOS IB */}
                                    {ibBachelor.grupos_ib && (
                                        <div className="grupos-ib">
                                            <Dropdown
                                                values={ibBachelor.grupos_ib}
                                            />
                                        </div>
                                    )}

                                    {/* COMPONENTES TRONCALES */}
                                    <div className="ib-bachelor-title">
                                        Componentes Troncales del Programa del Diploma
                                    </div>

                                    {ibBachelor.troncales_ib && (
                                        <div className="grupos-ib ib-bachelor-text">
                                            <Dropdown
                                                values={ibBachelor.troncales_ib}
                                            />
                                        </div>
                                    )}
                                </div>
                            ) : null}

                        </div>

                        {/* TAB 2 - PROGRAMA PAI (OCULTO TEMPORALMENTE) */}
                        {/*
                        <div className="program-tab-panel program-pai">
                            <div className="ib-bachelor-text">
                                <p>
                                    El Programa de Años Intermedios (PAI) ofrece una educación integral que
                                    desarrolla el pensamiento crítico, la investigación, la comunicación
                                    y la capacidad de aplicar los aprendizajes a situaciones reales.
                                    Su enfoque interdisciplinario y basado en conceptos coloca al
                                    estudiante en el centro de su proceso de aprendizaje.
                                </p>
                            </div>
                        </div>
                        */}
                    </div>

            </div>
        </div>
    );
};

export default IbBachelor;
